<template>
    <v-navigation-drawer
        v-model="drawer"          
        width="450"
        app
        temporary
        right
        class="wost-drawer"
    >
        <div class="form-head">
            {{ titleForm }}
        </div>

        <div class="pl-3 pt-3 pr-3">
            <v-card>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-autocomplete
                                    ref="brand_id"
                                    v-model="form.brand_id"
                                    :items="brands"
                                    label="Marca"
                                    outlined
                                    dense
                                    :item-text="customText"
                                    item-value="id"
                                    clearable
                                    :rules="[() => !!form.brand_id || 'Es necesario ingresar seleccionar una marca']"
                                    hide-details="auto"
                                    required
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    ref="name"
                                    v-model="form.name"
                                    label="Nombre de modelo"
                                    outlined
                                    dense
                                    :rules="[() => !!form.name || 'Es necesario ingresar un nombre']"
                                    hide-details="auto"
                                    required
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </div>

        <div class="pl-3 pt-3 pr-3">
            <template>
                <v-row>
                    <v-col cols="6">
                        <v-btn @click="handleCancel" 
                            block
                            dark
                            color="red">
                            Cancelar
                        </v-btn>
                    </v-col>
                    <v-col cols="6">
                        <v-btn v-if="action == 'create'"
                            dark 
                            color="green" 
                            block
                            @click="handleCreate">
                            Guardar
                        </v-btn>
                        <v-btn v-else
                            dark 
                            color="blue" 
                            block
                            @click="handleUpdate">
                            Actualizar
                        </v-btn>
                    </v-col>
                </v-row>
            </template>
        </div>
    </v-navigation-drawer>
</template>

<script>
import {mapState, mapActions} from 'vuex';

export default {
    name: 'CreateUpdate',
    data () {
        return {
            drawer: false,
            titleForm: null,
            action: null,
            form: {
                id: null,
                brand_id: null,
                name: null
            }
        }
    },
    computed: {
        ...mapState('brands', [
            'brands'
        ]),
        ...mapState('patterns', [
            'pattern_response'
        ])
    },
    methods: {
        ...mapActions('patterns', [
            'store',
            'update'
        ]),
        async show(title, action, pattern = null) {
            await this.clearErrors();
            this.titleForm = title;
            this.action = action;
            if (pattern) {
                this.setPattern(pattern);
            }
            this.drawer = !this.drawer;
        },
        clearForm () {
            this.form.id = null;
            this.form.brand_id = null;
            this.form.name = null;
            this.clearErrors();
        },
        closeForm () {
            this.clearForm();
            this.drawer = false;
        },
        setPattern (pattern) {
            this.form.id = pattern.id;
            this.form.brand_id = pattern.brand_id;
            this.form.name = pattern.name;
        },
        customText(item){
            let text = item.name
            
            return text
        },
        handleCancel () {
            this.closeForm();
        },
        async handleCreate () {
            if (!this.existErrors()) {
                await this.store(this.form);
                if (this.pattern_response == 'error') {
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: 'REGISTRO DE MODELO',
                        text: 'Ocurrió un error al registrar modelo.'
                    });
                } else {
                    this.closeForm();
                    this.$notify({
                        group: 'foo',
                        type: 'success',
                        title: 'REGISTRO DE MODELO',
                        text: 'Modelo registrado de forma correcta.'
                    });                    
                }
            }
        },
        async handleUpdate () {
            if (!this.existErrors()) {
                await this.update(this.form);
                if (this.pattern_response == 'error') {
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: 'ACTUALIZACION DE MODELO',
                        text: 'Ocurrió un error al actualizar modelo.'
                    });
                } else {
                    this.closeForm();
                    this.$notify({
                        group: 'foo',
                        type: 'success',
                        title: 'ACTUALIZACION DE MODELO',
                        text: 'Modelo actualizado de forma correcta.'
                    });
                }
            }
        },
        existErrors(){
            let hasErrors = false;

            Object.keys(this.form).forEach(f => {                
                if (this.$refs[f]) {
                    if (!this.form[f]) hasErrors = true
                    this.$refs[f].validate(true);
                }                
            });

            return hasErrors;
        },
        clearErrors() {
            Object.keys(this.form).forEach(f => {
                if (this.$refs[f]) this.$refs[f].reset()                
            });
        }
    }
}
</script>

<style scoped>

</style>